export enum Language {
  "de" = "de",
  "en" = "en",
  "fr" = "fr",
  "it" = "it",
  "es" = "es",
  "pt" = "pt",
}
